module.exports = __webpack_public_path__ + "img/mono_36.bf238de6.png";